import { makeAutoObservable } from 'mobx'

import { Collection } from './Collection'

import { UnionFieldModelType, UnionFieldResponseModel } from '../types/Field'
import GOFModel from './GOFModel'
import RecordModel from './RecordModel'

class GOFResponseModel {
   readonly gofResponseId: string

   gof: GOFModel

   record: RecordModel

   fieldResponsesCollection: Collection<string, UnionFieldResponseModel>

   constructor(gofResponseId: string, gof: GOFModel, record: RecordModel) {
      this.gofResponseId = gofResponseId
      this.gof = gof
      this.record = record
      this.fieldResponsesCollection = new Collection<
         string,
         UnionFieldResponseModel
      >('The Field response you are trying to access is not found')

      makeAutoObservable(this)
   }

   get fieldResponses(): UnionFieldResponseModel[] {
      return this.fieldResponsesCollection.orderedItems
   }

   getFieldResponseWithFieldId = (
      fieldId: string
   ): UnionFieldResponseModel | undefined =>
      this.fieldResponsesCollection.items.find(
         fieldResponse => fieldResponse.field.fieldId === fieldId
      )

   get isValid(): boolean {
      return true
   }
}

export default GOFResponseModel
